<template>
  <div style="overflow-y: auto;">
    <perfect-scrollbar style="max-height: 90vh;padding-left: 3%;padding-right: 3%;" class="dark:divide-gray-700;">
  <h1 class="text-2xl font-bold mb-4">Create Custom Action</h1>
  <div class="space-y-1 mb-4">
    <label class="block font-medium">Action Name</label>
    <input v-model="actionName" type="text" class="w-full p-2 border rounded-md focus:outline-none focus:ring"
      placeholder="Enter action name..." />
  </div>
  <div class="space-y-1 mb-4">
    <label class="block font-medium">HTTP Method</label>
    <select v-model="httpType" class="w-full p-2 border rounded-md focus:outline-none focus:ring">
      <option>GET</option>
      <option>POST</option>
      <option>PUT</option>
      <option>DELETE</option>
      <option>PATCH</option>
    </select>
  </div>
  <div class="space-y-1 mb-4">
    <div class="flex items-center mb-3" style="justify-content: space-between;">
      <label class="block font-medium mr-4">Headers</label>
      <button @click="addNewHeader"
        class="btn px-2 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none" style="">Add New
        Header</button>
    </div>
    <div v-if="headers.length>0" style="background-color: #f0f0f0;border-radius: 5px;font-size: 16px; padding:3%;overflow-y: auto;">
      <div v-for="header in headers" class="flex mb-2" >
        <input v-model="header.name" type="text" class="mr-2 w-full p-2 border rounded-md focus:outline-none focus:ring"
          placeholder="Enter Header Name..." />
        <input v-model="header.value" type="text" class="mr-2 w-full p-2 border rounded-md focus:outline-none focus:ring"
          placeholder="Enter Header Value..." />
        <button @click="removeHeader(header.id)" class="btn btn-accent" style="background-color: #ffadad; border: 1px solid #ffafaf;">Delete</button>
      </div>
    </div>
   
  </div>
  <div class="space-y-1 mb-4">
    <label class="block font-medium">API URL</label>
    <input v-model="url" type="text" class="w-full p-2 border rounded-md focus:outline-none focus:ring"
      placeholder="Enter endpoint URL..." />
  </div>
  <div class="space-y-1 mb-4">
    <div class="flex" style="justify-content: space-between;">
      <label class="block font-medium">Body (JSON)</label>
      <ToolTip>
        <h4 class="" style="font-size: 18px;font-weight: bold;">Available Variables</h4>
        <h3 class="mb-4">You can use variables from the conversation analysis.</h3>

        <div>
          <li style="font-size: 14px;font-weight: bold;">Summary</li>
          <div style="font-size: 10px;">The summary of the conversation</div>
        </div>

      </ToolTip>
    </div>


    <CodeMirrorIDE />
  </div>
  <div class="pt-4">
    <button @click="saveAction"
      class="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none">
      Save Action
    </button>
  </div>
</perfect-scrollbar>
</div>
</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import { Icon } from "@iconify/vue/dist/offline";
import ToolTip from "./Tooltip.vue";
import Tooltip from './Tooltip.vue';
import { uuid } from '@vueform/vueform';
import CodeMirrorIDE from '@/components/CodeMirrorIDE.vue';

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, 
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
const headers = ref([]);

function ResetHeaders(){
  headers.value = ref([]);
  addNewHeader();
}

function addNewHeader() {
  console.log(headers.length);
  headers.value.push({
    id:uuidv4(),
    name: "",
    value: ""
  });
}

function removeHeader(id) {
  console.log(id);
 headers.value=headers.value.filter(x => x.id !== id);
}

const knownVars = ref(["transcriptionArray", "summary"]);
const actionName = ref("");
const httpType = ref("GET");
const url = ref("");
const bodyContent = ref(`{
  "example": "{{ summary }}"
}`);
const editorContainer = ref(null);
let codeMirrorInstance = null;



function saveAction() {
  console.log("Action Saved:", {
    name: actionName.value,
    httpType: httpType.value,
    url: url.value,
    body: bodyContent.value
  });

  alert("Action saved! Check console for details.");
}

function applyVariableDecorations(content) {
  const doc = codeMirrorInstance.getDoc();
  const marks = doc.getAllMarks();
  marks.forEach(mark => mark.clear());
  const matches = [...content.matchAll(/\{\{\s*([^}]+)\s*\}\}/g)];
  for (let i = 0; i < matches.length; i = i + 1) {
    const match = matches[i];
    const varName = match[1].trim();
    const startPos = match.index;
    const endPos = startPos + match[0].length;
    if (startPos === undefined) {
      return;
    }
    const start = posToCodeMirrorPos(content, startPos);
    const end = posToCodeMirrorPos(content, endPos);
    const isKnown = knownVars.value.includes(varName);
    doc.markText(start, end, { className: isKnown === true ? "cm-variable-known" : "cm-variable-unknown" });
  }
}

function posToCodeMirrorPos(str, index) {
  const lines = str.substring(0, index).split("\n");
  const line = lines.length - 1;
  const ch = lines[lines.length - 1].length;
  return { line, ch };
}

onMounted(() => {
  headers.value = [{
  id:uuidv4(),
  name:"",
  value:""
}];


  codeMirrorInstance = CodeMirror(editorContainer.value, {
    value: bodyContent.value,
    mode: "application/json",
    lineNumbers: false,
    styleActiveLine: true,
    theme: "material-draker",
    matchBrackets: true,
    autoCloseBrackets: true,
    extraKeys: {
      "Ctrl-Space": "autocomplete"
    },
    hintOptions: {
      completeSingle: false,
      hint: (cm) => {
        const cur = cm.getCursor();
        const token = cm.getTokenAt(cur);
        const word = token.string;
        const start = token.start;
        const end = token.end;
        const suggestions = knownVars.value.filter(v => v.toLowerCase().startsWith(word.toLowerCase()));
        return {
          list: suggestions.length > 0 ? suggestions : knownVars.value,
          from: CodeMirror.Pos(cur.line, start),
          to: CodeMirror.Pos(cur.line, end)
        };
      }
    }
  });
  codeMirrorInstance.on("change", () => {
    bodyContent.value = codeMirrorInstance.getValue();
    applyVariableDecorations(bodyContent.value);
  });
  applyVariableDecorations(bodyContent.value);

 


  loadStyle(`
#editorContainer {
      height: 300px;
      border: 1px solid #ccc;
      background-color: #f9fafb;
    }
    .spin-me {
      animation: spin 1s linear infinite;
      transform-origin: center;
    }
      .CodeMirror-gutter-elt{
          display: none;
      }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .cm-variable-known {
      background-color: #c6f6d5 !important;
      color: #4a5568 !important;
    }
    .cm-variable-unknown {
      background-color: #fed7d7 !important;
      color: #4a5568 !important;
    }
  `);


});
function loadStyle(cssString) {

  const style = document.createElement('style');


  style.type = 'text/css';


  if (style.styleSheet !== undefined && style.styleSheet !== null) {
    style.styleSheet.cssText = cssString;
  } else {

    style.appendChild(document.createTextNode(cssString));
  }


  document.head.appendChild(style);
}


const crsConfig = ref({ "type": "classic", "responsive": false, "theme": "", "customPalette": [], "useCssAnimation": true, "useBlurOnHover": true, "userOptions": { "show": true, "position": "right", "buttons": { "tooltip": true, "pdf": false, "csv": true, "img": false, "table": true, "labels": true, "fullscreen": true, "sort": false, "stack": false, "animation": false, "annotator": true }, "buttonTitles": { "open": "Open options", "close": "Close options", "tooltip": "Toggle tooltip", "pdf": "Download PDF", "csv": "Download CSV", "img": "Download PNG", "table": "Toggle table", "labels": "Toggle labels", "fullscreen": "Toggle fullscreen", "annotator": "Toggle annotator" } }, "translations": { "total": "Total", "average": "Average" }, "table": { "show": false, "responsiveBreakpoint": 400, "th": { "backgroundColor": "#FFFFFFff", "color": "#1A1A1Aff", "outline": "none" }, "td": { "backgroundColor": "#FFFFFFff", "color": "#1A1A1Aff", "outline": "none", "roundingValue": 0, "roundingPercentage": 0 }, "columnNames": { "series": "Series", "value": "Value", "percentage": "Percentage" } }, "style": { "fontFamily": "inherit", "chart": { "useGradient": false, "gradientIntensity": "49", "backgroundColor": "#FFFFFFff", "color": "#1A1A1Aff", "layout": { "labels": { "dataLabels": { "show": true, "useLabelSlots": false, "hideUnderValue": 3, "prefix": "", "suffix": "" }, "value": { "rounding": 0, "show": false, "formatter": null }, "percentage": { "color": "#1A1A1Aff", "bold": true, "fontSize": 18, "rounding": 0, "formatter": null }, "name": { "color": "#1A1A1Aff", "bold": false, "fontSize": 16 }, "hollow": { "show": true, "total": { "show": true, "bold": false, "fontSize": 18, "color": "#AAAAAAff", "text": "Total", "offsetY": 0, "value": { "color": "#1A1A1Aff", "fontSize": 18, "bold": true, "suffix": "", "prefix": "", "offsetY": 0, "rounding": 0, "formatter": null } }, "average": { "show": true, "bold": false, "fontSize": 18, "color": "#AAAAAAff", "text": "Average", "offsetY": 0, "value": { "color": "#1A1A1Aff", "fontSize": 18, "bold": true, "suffix": "", "prefix": "", "offsetY": 0, "rounding": 0, "formatter": null } } } }, "donut": { "strokeWidth": 55, "borderWidth": 1, "useShadow": false, "shadowColor": "#1A1A1A" } }, "comments": { "show": true, "showInTooltip": true, "width": 100, "offsetY": 0, "offsetX": 0 }, "legend": { "show": true, "bold": false, "backgroundColor": "#FFFFFFff", "color": "#1A1A1Aff", "fontSize": 16, "roundingValue": 0, "roundingPercentage": 0 }, "tooltip": { "show": true, "color": "#1A1A1Aff", "backgroundColor": "#FFFFFFff", "fontSize": 14, "customFormat": null, "borderRadius": 4, "borderColor": "#e1e5e8", "borderWidth": 1, "backgroundOpacity": 30, "position": "center", "offsetY": 24, "showValue": true, "showPercentage": true, "roundingValue": 0, "roundingPercentage": 0 }, "title": { "text": "Conversation Resolution Status  (CRS) ", "color": "#1A1A1Aff", "fontSize": 18, "bold": false, "textAlign": "center", "paddingLeft": 0, "paddingRight": 0, "subtitle": { "color": "#A1A1A1ff", "text": "", "fontSize": 16, "bold": false } } } } })

const customerSentimentThisMonthConfig = ref({
  "theme": "",
  "style": {
    "fontFamily": "inherit",
    "chart": {
      "backgroundColor": "#FFFFFFff",
      "color": "#1A1A1Aff",
      "layout": {
        "grid": {
          "show": true,
          "stroke": "#e1e5e8ff",
          "strokeWidth": 0.6
        },
        "outerPolygon": {
          "stroke": "#e1e5e8ff",
          "strokeWidth": 1
        },
        "dataPolygon": {
          "color": "#6376DDff",
          "opacity": 60,
          "gradient": {
            "show": true,
            "intensity": 5
          },
          "stroke": "#6376DDff",
          "strokeWidth": 0.6
        },
        "smileys": {
          "strokeWidth": 1,
          "colors": {
            "1": "#e20001",
            "2": "#ff9f03",
            "3": "#ffd004",
            "4": "#9ac900",
            "5": "#059f00"
          }
        },
        "dataLabel": {
          "color": "#1A1A1Aff",
          "roundingValue": 0,
          "roundingPercentage": 0,
          "bold": true,
          "prefix": "",
          "suffix": "",
          "formatter": null
        }
      },
      "title": {
        "text": " Customer Sentiment This Month",
        "color": "#1A1A1Aff",
        "fontSize": 20,
        "bold": true,
        "textAlign": "center",
        "paddingLeft": 0,
        "paddingRight": 0,
        "subtitle": {
          "color": "#A1A1A1ff",
          "text": "",
          "fontSize": 16,
          "bold": false
        }
      },
      "legend": {
        "show": true,
        "bold": false,
        "backgroundColor": "#FFFFFFff",
        "color": "#1A1A1Aff",
        "fontSize": 14,
        "roundingValue": 0,
        "roundingPercentage": 0
      }
    }
  },
  "userOptions": {
    "show": true,
    "position": "right",
    "buttons": {
      "tooltip": false,
      "pdf": false,
      "csv": true,
      "img": true,
      "table": true,
      "labels": false,
      "fullscreen": true,
      "sort": false,
      "stack": false,
      "animation": false,
      "annotator": true
    },
    "buttonTitles": {
      "open": "Open options",
      "close": "Close options",
      "pdf": "Download PDF",
      "csv": "Download CSV",
      "img": "Download PNG",
      "table": "Toggle table",
      "fullscreen": "Toggle fullscreen",
      "annotator": "Toggle annotator"
    }
  },
  "table": {
    "show": false,
    "responsiveBreakpoint": 400,
    "columnNames": {
      "series": "Series",
      "value": "Value",
      "percentage": "Percentage"
    },
    "th": {
      "backgroundColor": "#FFFFFFff",
      "color": "#1A1A1Aff",
      "outline": "none"
    },
    "td": {
      "backgroundColor": "#FFFFFFff",
      "color": "#1A1A1Aff",
      "outline": "none",
      "roundingValue": 0,
      "roundingPercentage": 0
    }
  }
});


const mostSolvedIssuesConfig = ref({
  "theme": "",
  "responsive": false,
  "useCssAnimation": true,
  "table": {
    "show": false,
    "responsiveBreakpoint": 400,
    "th": {
      "backgroundColor": "#fafafaff",
      "color": "#2D353Cff",
      "outline": "none"
    },
    "td": {
      "backgroundColor": "#FFFFFFff",
      "color": "#2D353Cff",
      "outline": "none",
      "roundingValue": 0,
      "roundingPercentage": 0
    },
    "columnNames": {
      "series": "Step",
      "value": "Value",
      "percentage": "Percentage"
    }
  },
  "userOptions": {
    "show": true,
    "position": "right",
    "buttons": {
      "tooltip": true,
      "pdf": true,
      "csv": true,
      "img": true,
      "table": true,
      "labels": false,
      "fullscreen": true,
      "sort": false,
      "stack": false,
      "animation": false,
      "annotator": true
    },
    "buttonTitles": {
      "open": "Open options",
      "close": "Close options",
      "tooltip": "Toggle tooltip",
      "pdf": "Download PDF",
      "csv": "Download CSV",
      "img": "Download PNG",
      "table": "Toggle table",
      "fullscreen": "Toggle fullscreen",
      "annotator": "Toggle annotator"
    }
  },
  "style": {
    "fontFamily": "inherit",
    "chart": {
      "backgroundColor": "#FFFFFFff",
      "color": "#1A1A1Aff",
      "width": 600,
      "height": 500,
      "title": {
        "text": "Most Solved Issues",
        "color": "#1A1A1Aff",
        "fontSize": 20,
        "bold": true,
        "textAlign": "center",
        "paddingLeft": 0,
        "paddingRight": 0,
        "subtitle": {
          "color": "#A1A1A1ff",
          "text": "",
          "fontSize": 16,
          "bold": false
        }
      },
      "padding": {
        "top": 12,
        "right": 128,
        "bottom": 24,
        "left": 24
      },
      "barCircleSpacingRatio": 0.05,
      "circles": {
        "stroke": "#FFFFFFff",
        "strokeWidth": 1,
        "dataLabels": {
          "formatter": null,
          "fontSize": 16,
          "offsetY": 0,
          "adaptColorToBackground": true,
          "color": "#1A1A1Aff",
          "rounding": 1,
          "bold": true
        }
      },
      "circleLinks": {
        "show": true,
        "color": "#E1E5E8ff",
        "widthRatio": 1
      },
      "area": {
        "show": true,
        "color": "#E1E5E8ff"
      },
      "bars": {
        "stroke": "#FFFFFFff",
        "defaultColor": "#1F77B4",
        "strokeWidth": 1,
        "gapRatio": 0.2,
        "borderRadius": 3,
        "dataLabels": {
          "name": {
            "fontSize": 16,
            "color": "#1A1A1Aff",
            "bold": true,
            "offsetX": 0,
            "offsetY": 0
          },
          "value": {
            "formatter": null,
            "fontSize": 16,
            "rounding": 0,
            "bold": false,
            "color": "#1A1A1Aff",
            "prefix": "",
            "suffix": "",
            "offsetX": 0,
            "offsetY": 0
          }
        }
      }
    }
  }
});

const topUsedTopicsConfig = ref({
  "theme": "",
  "customPalette": [],
  "style": {
    "fontFamily": "inherit",
    "backgroundColor": "#FFFFFFff",
    "animation": {
      "show": true,
      "animationFrames": 60
    },
    "layout": {
      "independant": true,
      "percentage": true,
      "target": 0,
      "showTargetValue": false,
      "targetValueText": ""
    },
    "gutter": {
      "backgroundColor": "#ffffffff",
      "opacity": 100
    },
    "bar": {
      "gradient": {
        "show": false,
        "intensity": 40,
        "underlayerColor": "#FFFFFF"
      }
    },
    "labels": {
      "fontSize": 16,
      "name": {
        "position": "top-left",
        "width": "100%",
        "color": "#1A1A1Aff",
        "bold": true
      },
      "value": {
        "show": true,
        "bold": true
      }
    },
    "title": {
      "text": "Top Used Topics",
      "color": "#1A1A1Aff",
      "fontSize": 18,
      "bold": false,
      "textAlign": "center",
      "margin": "0 0 10px 0",
      "subtitle": {
        "color": "#CCCCCCff",
        "text": "",
        "fontSize": 16,
        "bold": false
      }
    },
    "gap": 4
  }
});


const dataset = ref([
  {
    "name": "קושי התחברות לאתר",
    "value": 40,
    "color": "#6376DD",
    "prefix": "",
    "suffix": "%",
    "rounding": 1
  },
  {
    "name": "התנתקות מהשירות",
    "value": 22,
    "color": "#42d392",
    "prefix": "",
    "suffix": "%",
    "rounding": 1
  },
  {
    "name": "התחברות לשירות הסלולר",
    "value": 18,
    "color": "#ff6400",
    "prefix": "",
    "suffix": "%",
    "rounding": 1
  },
  {
    "name": "קבלת הנחה בחבילה",
    "value": 13,
    "color": "#f3eb12",
    "prefix": "",
    "suffix": "%"
  },
  {
    "name": "תקלת הפעלת חבילת סלולר",
    "value": 4,
    "color": "#e90c0c",
    "prefix": "",
    "suffix": "%"
  },
  {
    "name": "שינוי מספר כרטיס אשראי",
    "value": 2,
    "color": "#b37575",
    "prefix": "",
    "suffix": "%"
  },
  {
    "name": "החלפת חבילה לשילוב",
    "value": 1,
    "color": "#ec3ccc",
    "prefix": "",
    "suffix": "%"
  }
]);

const commonFoundIssuesConfig = ref({ "theme": "", "customPalette": [], "style": { "fontFamily": "inherit", "backgroundColor": "#ffffff00", "animation": { "show": true, "animationFrames": 60 }, "layout": { "independant": true, "percentage": true, "target": 0, "showTargetValue": false, "targetValueText": "" }, "gutter": { "backgroundColor": "#e1e5e8ff", "opacity": 100 }, "bar": { "gradient": { "show": false, "intensity": 40, "underlayerColor": "#FFFFFF" } }, "labels": { "fontSize": 16, "name": { "position": "top-left", "width": "100%", "color": "#1A1A1Aff", "bold": true }, "value": { "show": true, "bold": true } }, "title": { "text": "Common Issues", "color": "#1A1A1Aff", "fontSize": 18, "bold": false, "textAlign": "center", "margin": "0 0 10px 0", "subtitle": { "color": "#CCCCCCff", "text": "", "fontSize": 16, "bold": false } }, "gap": 4 } })
function detectTextDirection(text) {
  const rtlChars = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  return rtlChars.test(text) === true && text !== undefined && text !== null && text !== '' ? 'rtl' : 'ltr';
}
function textDirectionClass(text) {
  return detectTextDirection(text) === 'rtl' ? 'text-rtl heebo-text' : 'text-ltr';
}

const crsOverMonthsConfig = ref({
  "userOptions": {
    "show": false,
    "position": "right",
    "buttons": {
      "tooltip": true,
      "pdf": true,
      "csv": true,
      "img": true,
      "table": true,
      "labels": true,
      "fullscreen": true,
      "sort": false,
      "stack": false,
      "animation": false,
      "annotator": true
    }
  },
  "style": {
    "fontFamily": "inherit",
    "chart": {
      "backgroundColor": "#FFFFFFff",
      "color": "#2D353Cff",
      "height": 500,
      "width": 800,
      "padding": {
        "top": 12,
        "right": 12,
        "bottom": 36,
        "left": 48
      },
      "title": {
        "text": "Conversation Resolution Status (CRS)",
        "color": "#1A1A1Aff",
        "fontSize": 17,
        "bold": true,
        "textAlign": "center",
        "paddingLeft": 0,
        "paddingRight": 0,
        "subtitle": {
          "color": "#514d4dff",
          "text": "Over months",
          "fontSize": 18,
          "bold": false
        }
      }
    }
  }
});


const crsOverMonthsDataset = ref([
  {
    "name": "Solved",
    "series": [
      10,
      20,
      30
    ],
    "color": "#5f8aee"
  },
  {
    "name": "Didn't Solve",
    "series": [
      20,
      40,
      60
    ],
    "color": "#42d392"
  }
]);

const followUpConfig = ref({
  "theme": "",
  "style": {
    "fontFamily": "inherit",
    "background": "#FFFFFF",
    "height": 14,
    "width": 20,
    "basePosition": 72,
    "animation": {
      "show": true,
      "speedMs": 150
    },
    "title": {
      "show": true,
      "fontSize": 18,
      "position": "top",
      "textAlign": "center",
      "bold": false,
      "color": "#1A1A1Aff"
    },
    "dataLabel": {
      "fontSize": 20,
      "autoColor": true,
      "color": "#1A1A1Aff",
      "offsetY": 0,
      "bold": true,
      "rounding": 0,
      "prefix": "",
      "suffix": "%",
      "formatter": null
    },
    "colors": {
      "min": "#FF0000",
      "max": "rgba(0, 255, 0, 1)",
      "showGradient": false
    },
    "track": {
      "autoColor": false,
      "color": "#5f8bee99",
      "strokeLinecap": "round"
    },
    "gutter": {
      "color": "#e1e5e8ff",
      "strokeLinecap": "round"
    }
  }
});


const npsConfig = ref({
  "theme": "",
  "style": {
    "fontFamily": "inherit",
    "background": "#FFFFFF",
    "height": 14,
    "width": 20,
    "basePosition": 72,
    "animation": {
      "show": true,
      "speedMs": 150
    },
    "title": {
      "show": true,
      "fontSize": 18,
      "position": "top",
      "textAlign": "center",
      "bold": false,
      "color": "#1A1A1Aff"
    },
    "dataLabel": {
      "fontSize": 20,
      "autoColor": true,
      "color": "#1A1A1Aff",
      "offsetY": 0,
      "bold": true,
      "rounding": 0,
      "prefix": "",
      "suffix": "%",
      "formatter": null
    },
    "colors": {
      "min": "#FF0000",
      "max": "rgba(0, 255, 0, 1)",
      "showGradient": false
    },
    "track": {
      "autoColor": false,
      "color": "#42d392ff",
      "strokeLinecap": "round"
    },
    "gutter": {
      "color": "#e1e5e8ff",
      "strokeLinecap": "round"
    }
  }
});


const npsDataset = ref({
  "value": 50,
  "min": 0,
  "max": 100,
  "title": "Net Promoter Score (NPS)"
});
const followUpDataset = ref({
  "value": 83,
  "min": 0,
  "max": 100,
  "title": "Follow Up Conversations"
});

const topUsedTopicsDataset = ref([{ "name": "קושי התחברות לאתר", "value": 40, "color": "#6376DD", "prefix": "", "suffix": "%", "rounding": 1 }, { "name": "התנתקות מהשירות", "value": 22, "color": "#42d392", "prefix": "", "suffix": "%", "rounding": 1 }, { "name": "התחברות לשירות הסלולר", "value": 18, "color": "#ff6400", "prefix": "", "suffix": "%", "rounding": 1 }, { "name": "קבלת הנחה בחבילה", "value": 13, "color": "#f3eb12", "prefix": "", "suffix": "%" }]);

const commonFoundIssuesDataset = ref([{ "name": "תקלות התחברות לאתר", "percentage": 3.3333, "color": "#42d392", "value": 150, "prefix": "", "suffix": "%" }, { "name": "תקלות בחיבור לרשת ", "percentage": 3.3333, "color": "#42d392", "value": 150, "prefix": "", "suffix": "%" }, { "name": "קליטה גרועה בבאר שבע", "percentage": 33.334, "color": "#5f8bee", "value": 130, "prefix": "", "suffix": "%" }, { "name": "ממשק האתר נוראי", "percentage": 63.333, "color": "#ff6400", "value": 12, "prefix": "", "suffix": "%" }]);

const customerSentimentThisMonthDataset = ref({
  "1": 12,
  "2": 20,
  "3": 36,
  "4": 65,
  "5": 75
});

const mostSolvedIssuesDataset = ref([
  {
    "name": "בעיה במזגן",
    "value": 8249
  },
  {
    "name": "בעייה בטלפון",
    "value": 6322
  },
  {
    "name": "תקלה באתר",
    "value": 4562
  },
  {
    "name": "תקלה באפליקציה ",
    "value": 3021
  },
  {
    "name": "תקלה בממשק",
    "value": 1412
  }
]);

const crsDataset = ref([{ "name": "Solved", "values": [100], "color": "#1f77b4" }, { "name": "Didn't Solve", "values": [40], "color": "#e47f21" }]);


</script>
